[
  {
    "name": "$ad_platform",
    "displayName": "Ad Platform",
    "description": "Platform where the advertisement is displayed.",
    "type": "string",
    "exampleValue": "Google, Facebook"
  },
  {
    "name": "utm_source",
    "displayName": "UTM Source",
    "description": "Identifies which site sent the traffic.",
    "type": "string",
    "exampleValue": "Facebook, LinkedIn"
  },
  {
    "name": "utm_medium",
    "displayName": "UTM Medium",
    "description": "Identifies what type of link sent traffic.",
    "type": "string",
    "exampleValue": "Email, Pay per Click Ads"
  },
  {
    "name": "utm_campaign",
    "displayName": "UTM Campaign",
    "description": "Identifies which promotion sent traffic (by campaign name).",
    "type": "string",
    "exampleValue": "Summer Sale, Free Trial"
  },
  {
    "name": "utm_campaign_id",
    "displayName": "UTM Campaign ID",
    "description": "Identifies which promotion sent traffic (by campaign ID; alternative for utm_id).",
    "type": "string",
    "exampleValue": "facebook_456def"
  },
  {
    "name": "utm_content",
    "displayName": "UTM Content",
    "description": "Identifies the exact element on your ad that was clicked. For example, if you have two call-to-actions within the same email message with one being a video_ad and another being a green_banner ad.",
    "type": "string",
    "exampleValue": "Pricing, Sales"
  },
  {
    "name": "utm_creative_format",
    "displayName": "UTM Creative Format",
    "description": "Identifies the type of creative that sent traffic (e.g., display, native, video, search).",
    "type": "string",
    "exampleValue": "video"
  },
  {
    "name": "utm_id",
    "displayName": "UTM ID",
    "description": "Identifies which promotion sent traffic (by campaign ID).",
    "type": "string",
    "exampleValue": "facebook_456def"
  },
  {
    "name": "utm_marketing_tactic",
    "displayName": "UTM Marketing Tactic",
    "description": "Identifies targeting criteria applied to a campaign (e.g., remarketing, prospecting).",
    "type": "string",
    "exampleValue": "remarketing"
  },
  {
    "name": "utm_source_platform",
    "displayName": "UTM Source Platform",
    "description": "Identifies which ad platform sent traffic.",
    "type": "string",
    "exampleValue": "Search Ads 360"
  },
  {
    "name": "utm_term",
    "displayName": "UTM Term",
    "description": "Identifies paid keywords driving traffic.",
    "type": "string",
    "exampleValue": "google_analytics_alternatives, marketing_analytics"
  },
  {
    "name": "$ad_cost",
    "displayName": "Cost",
    "description": "Money spent to run advertisements.",
    "type": "number"
  },
  {
    "name": "$ad_clicks",
    "displayName": "Clicks",
    "description": "Number of clicks on an advertisement.",
    "type": "number"
  },
  {
    "name": "$ad_impressions",
    "displayName": "Impressions",
    "description": "Number of views on an advertisement.",
    "type": "number"
  }
]
